import './OpDropdownButton.scss'

import React from "react";
import OpButton from "common/views/components/OpButton";

const DefaultListItem = ({ children, className, onClick, onMouseEnter }) => (
  <div onMouseDown={(e) =>{ if (e.button === 0) { onClick(e) }}} onMouseEnter={onMouseEnter} className={className}>
    { children }
  </div>
)

class OpDropdownButton extends React.Component {
  state = {
    isOpen: false,
    selectedIndex: 0,
  }

  resetDropdown() {
    this.setState({ isOpen: false, selectedIndex: 0 })
  }

  render() {
    const {
      onOptionSelect,
      getLabelFromItem,
      buttonLabel,
      hidden,
      items,
      className,
    } = this.props

    if (hidden) {
      return <div/>
    }

    const clazzName = className ? `OpDropdownButton ${className}` : 'OpDropdownButton'
    return (
      <div className={clazzName} onMouseLeave={() => this.resetDropdown()}>
        <div className={`toggleButton`}>
          <OpButton
            bsStyle="secondary-black"
            className={'OpDropdownButton__toggleButton--button'}
            onClick={() => this.setState({ isOpen: !this.state.isOpen })}
          >
            {buttonLabel}
          </OpButton>
        </div>
        { this.state.isOpen && <div className={'OpDropdownButton__menuOptions'}>
            {_.map(items, (item, idx) => {
              return (
                <DefaultListItem
                  className={`OpDropdownButton__menuOptions--option ${idx === this.state.selectedIndex && '--selected'}`}
                  key={idx}
                  onMouseEnter={() => {
                    this.setState({selectedIndex: idx})
                  }}
                  onClick={() => {
                    onOptionSelect(item)
                    this.resetDropdown()
                  }}
                >
                  {getLabelFromItem(item)}
                </DefaultListItem>
              )
            })}
          </div>
        }
      </div>
    )
  }
}

export default OpDropdownButton
